<script setup lang="ts">
import type { Company } from "../../types/auth";
import { tokenManager } from "../../api/utils/tokenManager";
//import { useRouter } from 'vue-router'
import { api } from "../../api/Api";
import { onMounted, ref } from "vue";
import MessageBox from "../../services/MessageBox";
import AsyncImage from "../ui/form/AsyncImage.vue";

defineProps<{
  //companies: Company[]
}>();

defineEmits<{
  (e: "select", company: Company): void;
  (e: "close"): void;
}>();

//const router = useRouter()

const companies = ref<Company[]>([]);

const handleSelect = async (company: Company) => {
  const apiData = {
    cid: company.uid,
    email: tokenManager.getUser()?.email,
    password: tokenManager.getPassword() || "",
  };
  const response = await api.post("/company", apiData);
  if (response.success == true) {
    tokenManager.setMenu(response.data.menu);
    tokenManager.setPermissions(response.data.permissions);
    tokenManager.setSettings(response.data.settings);
    tokenManager.setCompany(company);
    tokenManager.setUser(response.data.user);
    const user = response.data.user;
    if (response.data.welcomed && user?.user_type == "Back Office") {
      window.location.href = "/dashboard";
    } else if (user?.user_type == "POS User") {
      window.location.href = "/pos";
    } else if (user?.user_type == "Delivery") {
      window.location.href = "/delivery-trackings";
    } else if (user?.user_type == "Sales Rep") {
      window.location.href = "/reps";
    } else if (!response.data.welcomed && user?.user_type == "Back Office") {
      window.location.href = "/welcome";
    } else {
      MessageBox.show(
        "Please contact your administrator to set up your account."
      );
    }
  }
};

onMounted(async () => {
  companies.value = await tokenManager.getCompanyList();
});
</script>

<template>
  <div
    class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 w-full"
  >
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-3xl">
      <div class="p-6">
        <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Select Company
        </h2>
        <p class="text-gray-600 dark:text-gray-400 mb-6">
          Please select a company to continue:
        </p>

        <div class="grid grid-cols-2 gap-4 max-h-[600px] overflow-y-auto">
          <button
            v-for="company in companies"
            :key="company.uid"
            @click="handleSelect(company)"
            class="p-4 bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-colors text-left"
          >
            <div class="justify-between items-center">
              <div class="w-[100px]">
                <AsyncImage
                  v-if="company.logo"
                  :src="company.logo"
                  alt="Company Logo"
                  className="w-25 h-25 rounded-full mr-3"
                />
              </div>
              <div>
                <h3 class="font-medium text-gray-900 dark:text-white">
                  {{ company.company_name }}
                </h3>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  License expires:
                  {{ new Date(company.license_expiry).toLocaleDateString() }}
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
